<template>
  <div
    class="m-0"
    :class="fullScreen ? 'soha-field-full-screen' : 'soha-field-box'"
  >
    <div class="soha-field-item soha-field-title">
      <span> {{ title }} </span>
    </div>

    <div class="soha-field-item soha-field-value">
      <span
        :class="{ 'direction-ltr': ltrText }"
        v-html="fieldValue"
      />
    </div>
  </div>
</template>

<script>
import "@/assets/css/components/resume/resume-field.css";
export default {
  name: "Field",

  props: {
    title: String,
    value: [String, Number],
    ltrText: Boolean,
    fullScreen: {
      type: Boolean,
      default: false,
    }
  },

  computed: {
    fieldValue() {
      if (typeof this.value == "number") return this.value;
      return this.value.replaceAll("\n", "</br>");
    },
  },
};
</script>
